/* CUSTOM JV — bara de marimi pe card: la click pe o marime, seteaza id-ul variantei
   in input-ul ascuns, apoi submit-ul e preluat de <product-form-component> (nativ Horizon). */
(function () {
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target.closest('.jv-card-sizes__btn');
      if (!btn || btn.disabled) return;
      var form = btn.closest('form');
      if (!form) return;
      var input = form.querySelector('input[name="id"]');
      if (input && btn.dataset.jvVariant) input.value = btn.dataset.jvVariant;
      btn.classList.add('is-adding');
      setTimeout(function () { btn.classList.remove('is-adding'); }, 1200);
    },
    true
  );
  // nu lasa click-ul pe bara de marimi sa deschida pagina produsului (link-ul cardului e overlay)
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-jv-card-sizes]')) e.stopPropagation();
  });
})();
